import { Button } from "@/components/elements/Button";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { logout } from "@/utils/logout";
import { createUrlWithParams } from "@/utils/url";
import { Paper, Stack, styled, Typography } from "@mui/material";
import { FC } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

type TRegisterCompleteState = {
  email?: string;
  externalId?: string;
};

export const RegisterCompletePage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state ?? null) as TRegisterCompleteState | null;

  if (!state?.email || !state?.externalId) {
    return <Navigate to={AppRoutes.login} replace />;
  }

  const handleGoToLogin = async () => {
    await logout();
    const url = createUrlWithParams(AppRoutes.loginCredentials, { email: state.email, externalId: state.externalId });
    navigate(url);
  };

  return (
    <Stack gap="50px" alignItems="center">
      <LoginLogo />
      <Container>
        <Stack flexDirection="column" alignItems="center" width={464}>
          <Typography variant="head20Bold" color={text.primary}>
            アカウントの登録完了
          </Typography>
          <Stack flexDirection="column" justifyContent="start" mt="32px" mb="48px" width="100%">
            <Typography variant="body14" color={text.secondary}>
              irohanaアカウントの登録が完了しました。
            </Typography>
            <Typography variant="body14" color={text.secondary}>
              ログイン後、ご契約中のプロダクトを選ぶことで利用できます。
            </Typography>
          </Stack>
          <Button type="submit" variant="primary" fullWidth onClick={handleGoToLogin}>
            <Typography variant="body14Semi">ログイン画面へ</Typography>
          </Button>
        </Stack>
      </Container>
    </Stack>
  );
};

const Container = styled(Paper)`
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 4px 4px -1px rgba(12, 12, 13, 0.05),
    0 4px 4px -1px rgba(12, 12, 13, 0.1) !important;
`;
